'use client'

import React, { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { Button } from './Button'
import { cn } from './utils'

export interface CopyButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  value: string
  variant?: 'default' | 'outline' | 'ghost'
  size?: 'default' | 'sm' | 'lg' | 'icon'
  successDuration?: number
}

const CopyButton = React.forwardRef<HTMLButtonElement, CopyButtonProps>(
  ({ className, value, variant = 'outline', size = 'sm', successDuration = 2000, ...props }, ref) => {
    const [copied, setCopied] = useState(false)

    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(value)
        setCopied(true)
        setTimeout(() => setCopied(false), successDuration)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    }

    return (
      <Button
        ref={ref}
        variant={variant}
        size={size}
        className={cn(
          'transition-all duration-200',
          copied && 'text-success-600 border-success-600',
          className
        )}
        onClick={handleCopy}
        {...props}
      >
        {copied ? (
          <Check className="h-4 w-4" />
        ) : (
          <Copy className="h-4 w-4" />
        )}
        {size !== 'icon' && (
          <span className="ml-2">
            {copied ? 'Copied!' : 'Copy'}
          </span>
        )}
      </Button>
    )
  }
)

CopyButton.displayName = 'CopyButton'

export { CopyButton }
